/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTrophy } from '@fortawesome/free-solid-svg-icons';

import { useSelector } from 'react-redux';

import injectSheet from 'react-jss';

import { getNumOfPicks } from '../../redux/features/picks/picks';

const styles = () => ({
  stages: {
    position: 'fixed',
    backgroundColor: '#fff',
    borderTop: '1px solid #ddd',
    // bottom: '54px',
    width: '100%',
  },
  stage: {},
  bracketSection: {},
  groups: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    gridColumnGap: '10px',
    backgroundColor: 'rgba(255,255,0,.2)',
  },
  group: {
    padding: '9px',
  },
  group_match: {
    height: '1px',
    backgroundColor: '#666',
    marginBottom: '3px',
  },
  match: {
    height: '1px',
    backgroundColor: '#666',
    marginBottom: '2px',
  },
  trans: {
    height: '1px',
    marginBottom: '2px',
  },
  space: {
    height: '2px',
  },
  rounds: {
    composes: '$stage',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
  },
  round: {
    composes: ['$bracketSection'],
    alignSelf: 'center',
    padding: '9px',

  },
  check: {
    position: 'absolute',
    marginLeft: '1%',
    color: '#62B020',
  },
  progressbar: {
    height: '2px',
    backgroundColor: '#62B020',
    transition: 'width .6s ease',
  },
});

const MobileNav = ({
  classes,
  history,
  match,
}) => {
  const numOfPicks = useSelector((state) => getNumOfPicks(state));
  useEffect(() => {
    if (history.location.pathname === '/') {
      history.push('/groups');
    }
  }, []);

  return (
    <div
      className={classes.stages}
      style={{ bottom: numOfPicks.final === 1 ? 73 : 0 }}
    >
      <div className={classes.progressbar} style={{ width: `${(100 * numOfPicks.totalpicks) / 32}%` }} />

      <div
        className={classes.groups}
        onClick={() => { history.push('/groups'); }}
        style={{ backgroundColor: match.params.stage === 'groups' ? 'rgba(255,255,0,.2)' : '#fff', border: match.params.stage === 'groups' ? '2px solid rgb(255,255,0)' : '2px solid #fff' }}
      >
        <div className={classes.group}>
          {numOfPicks.a === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.a === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.b === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.b === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.c === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.c === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.d === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.d === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.e === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.e === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.f === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.f === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.g === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.g === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
        <div className={classes.group}>
          {numOfPicks.h === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.h === 2 ? '0.1' : '1' }}>
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
            <div className={classes.group_match} />
          </div>
        </div>
      </div>
      <div className={classes.rounds}>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/eighths'); }}
          style={{ backgroundColor: match.params.bracketSection === 'eighths' ? 'rgba(255,255,0,.2)' : '#fff', border: match.params.bracketSection === 'eighths' ? '2px solid rgb(255,255,0)' : '2px solid #fff' }}
        >
          {numOfPicks.eighths === 8 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.eighths === 8 ? '0.1' : '1' }}>
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/quarters'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'quarters' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'quarters' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >
          {numOfPicks.quarters === 4 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.quarters === 4 ? '0.1' : '1' }}>
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/semis'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'semis' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'semis' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >
          {numOfPicks.semis === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}

          <div style={{ opacity: numOfPicks.semis === 2 ? '0.1' : '1' }}>
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/thirdplace'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'thirdplace' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'thirdplace' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >

          {numOfPicks.thirdplace === 1 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.thirdplace === 1 ? '0.1' : '1' }}>
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/final'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'final' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'final' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >
          {numOfPicks.final === 1 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.final === 1 ? '0.1' : '1' }}>
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/semis'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'semis' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'semis' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >
          {numOfPicks.semis === 2 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.semis === 2 ? '0.1' : '1' }}>
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/quarters'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'quarters' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'quarters' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >
          {numOfPicks.quarters === 4 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.quarters === 4 ? '0.1' : '1' }}>
            <div className={classes.trans} />
            <div className={classes.trans} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.trans} />
            <div className={classes.trans} />
          </div>
        </div>
        <div
          className={classes.round}
          onClick={() => { history.push('/ko/eighths'); }}
          style={{
            backgroundColor: match.params.bracketSection === 'eighths' ? 'rgba(255,255,0,.2)' : '#fff',
            border: match.params.bracketSection === 'eighths' ? '2px solid rgb(255,255,0)' : '2px solid #fff',
          }}
        >
          {numOfPicks.eighths === 8 && (<FontAwesomeIcon icon={faCheck} className={classes.check} />)}
          <div style={{ opacity: numOfPicks.eighths === 8 ? '0.1' : '1' }}>
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
            <div className={classes.space} />
            <div className={classes.match} />
            <div className={classes.match} />
          </div>
        </div>
      </div>
    </div>
  );
};

MobileNav.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default injectSheet(styles)(MobileNav);
